<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">URL</div>
            </div>
            <input
                type="url"
                class="form-control"
                required
                pattern="https://.+"
                v-model="url"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: E-post</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldEmail"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Person-ID</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldPersonId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Banknamn</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldBankName"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Clearing</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldClearingNumber"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Kontonummer</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldAccountNumber"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Kampanjkod</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldCampaignCode"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Standardvärde: Kampanjkod</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="defaultCampaignCode"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Medlemskap kampanjkod</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldMembershipCampaignCode"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Standardvärde: Medlemskap kampanjkod</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="defaultMembershipCampaignCode"
                @input="onUpdate"
            />
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const url = ref(null);
const fieldEmail = ref(null);
const fieldPersonId = ref(null);
const fieldBankName = ref(null);
const fieldClearingNumber = ref(null);
const fieldAccountNumber = ref(null);
const fieldCampaignCode = ref(null);
const fieldMembershipCampaignCode = ref(null);
const defaultCampaignCode = ref(null);
const defaultMembershipCampaignCode = ref(null);
const serializedValue = computed(() => {
  return {
    url: url.value,
    field_email: fieldEmail.value,
    field_person_id: fieldPersonId.value,
    field_bank_name: fieldBankName.value,
    field_clearing_number: fieldClearingNumber.value,
    field_account_number: fieldAccountNumber.value,
    field_campaign_code: fieldCampaignCode.value,
    field_membership_campaign_code: fieldMembershipCampaignCode.value,
    default_campaign_code: defaultCampaignCode.value,
    default_membership_campaign_code: defaultMembershipCampaignCode.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    url.value = modelValue.value.url;
    fieldEmail.value = modelValue.value.field_email;
    fieldPersonId.value = modelValue.value.field_person_id;
    fieldBankName.value = modelValue.value.field_bank_name;
    fieldClearingNumber.value = modelValue.value.field_clearing_number;
    fieldAccountNumber.value = modelValue.value.field_account_number;
    fieldCampaignCode.value = modelValue.value.field_campaign_code;
    fieldMembershipCampaignCode.value = modelValue.value.field_membership_campaign_code;
    defaultCampaignCode.value = modelValue.value.default_campaign_code;
    defaultMembershipCampaignCode.value = modelValue.value.default_membership_campaign_code;
  }
}, {
  immediate: true
});
</script>
